module.exports = __webpack_public_path__ + "img/num-1.97957047.svg";